import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseTemplateForm from '../../../components/forms/ExerciseTemplateForm';
import { useExerciseTemplateApi } from '../../../hooks/useExerciseTemplateApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ExerciseTemplateDTO } from '../../../services/apiClient';

const ExerciseTemplateEdit: React.FC = () => {
  const { getById, edit } = useExerciseTemplateApi();
  const [entityData, setEntityData] = useState<ExerciseTemplateDTO | null>(
    null,
  );
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Templates', href: '/admin/exercisetemplates' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ExerciseTemplate data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/exercisetemplates');
    } catch (error) {
      console.error('Error updating ExerciseTemplate:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisetemplates"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ExerciseTemplate.Edit"
    >
      {entityData ? (
        <ExerciseTemplateForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/exercisetemplates')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ExerciseTemplateEdit;
